import { Checkbox, Col, Flex, Row } from "antd";
import ButtonComponent from "components/button/Button";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import PopupConfirm from "components/popup-confirm";
import TableComponent from "components/table/Table";
import {
  apiDeleteDevice,
  apiGetAllDevices,
} from "helpers/api/devices";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { showToastError, showToastSuccess } from "utils";
import "./styles.scss";

const AdminSettingDevicePage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [loading, setLoading] = useState(0);
  const [devices, setDevices] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });

  const columns = [
    {
      title: "no",
      dataIndex: "no",
      align: "center",
      key: "no",
    },
    {
      title: "MACアドレス",
      dataIndex: "macR",
      align: "center",
      key: "mac",
    }
  ];

  const getDevices = (newPage) => {
    setLoading((prev) => prev + 1);
    let keySearch = "";
    if(searchInput){
      keySearch = searchInput.replaceAll(":", "")
      .match( /.{1,2}/g)         
      .join( ':')
    }
    console.log(keySearch)
    apiGetAllDevices({mac: keySearch, page: newPage})
      .then((res) => {
        console.log(res);
        if (res.error) {
          showToastError(res.error.message);
        } else {
          setDevices(res);
        }
      })
      .catch(({ error }) => {
        // showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onRowClick = (record) => {
    console.log(record);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDeleteDevice = () => {
    setIsOpenDelete(false);
    setLoading((prev) => prev + 1);
    apiDeleteDevice({
      macs: selectedRowKeys,
    })
      .then((res) => {
        if (res.error) {
          showToastError("サーバーへ転送したデータが無効です。");
          setSelectedRowKeys([]);
        }
        if (res.data) {
          showToastSuccess("デバイスが正常に削除されました。");
          setSelectedRowKeys([]);
          getDevices(1);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
        setSelectedRowKeys([]);
      });
  };

  useEffect(() => {
    getDevices();
  }, []);

  return (
    <div className="main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("clinic.clinic_title")}</div>
      </div>
      <div className="nav screen-title">お知らせライト管理一覧</div>
      <div className="content">
        <Container>
          <Row>
            <Col md={7}>
              <InputComponent
                suffix={
                  <img
                    src="/icons/search_img.png"
                    className="ic x2"
                    alt="icon-search"
                    onClick={() => getDevices(1)}
                  />
                }
                placeholder="検索"
                onChange={(e) => setSearchInput(e.target.value)}
                onEnter={() => getDevices(1)}
              />
            </Col>
            <Col offset={1}>
              <ButtonComponent
                background="#fb5757"
                className="btn_block"
                text={t("clinic.delete")}
                onClick={() => setIsOpenDelete(true)}
                disabled={selectedRowKeys.length === 0}
              />
            </Col>
          </Row>
          <TableComponent
            columns={columns}
            dataSource={devices.data.map((item, index) => ({
              ...item,
              no: index + 1,
              macR: item.mac ? item.mac.replaceAll(":","") : "",
              key: item.mac,
            }))}
            rowSelection={rowSelection}
            pageSize={15}
            showPagination={false}
            showPage={false}
            onRow={onRowClick}
          />
          <Row
            style={{
              marginTop: "20px",
              justifyContent: "flex-end",
              padding: "0 20px",
            }}
          >
            <Col style={{ display: "flex" }}>
              {`${devices.page}/${devices.total_page} ${t("notices.page")}　`}
              <Flex gap="10px">
                {devices.page > 1 ? (
                  <span
                    style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                    onClick={() => {
                      setDevices((prev) => ({ ...prev, page: prev.page - 1 }));
                      getDevices(devices.page - 1);
                    }}
                  >
                    ▶
                  </span>
                ) : null}
                {devices.page < devices.total_page ? (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setDevices((prev) => ({ ...prev, page: prev.page + 1 }));
                      getDevices(devices.page + 1);
                    }}
                  >
                    ▶
                  </span>
                ) : null}
              </Flex>
            </Col>
          </Row>
        </Container>
      </div>
      <PopupConfirm
        open={isOpenDelete}
        onCancelText={t("button.cancel")}
        onOkText={t("button.delete")}
        content="デバイスのMACアドレスを本当に削除しますか？"
        onOk={() => handleDeleteDevice()}
        onCancel={() => setIsOpenDelete(false)}
        onOkColor="#FF3131"
      />
      {loading ? <Loading /> : null}
    </div>
  );
};

export default AdminSettingDevicePage;
